import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { CarProfile } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("alenookie@gmail.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Selamat datang kembali");
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login gagal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div
        className="hidden lg:block relative"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1618642624018-a370cbf3cd80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXIlMjBzaG93cm9vbXxlbnwwfHx8fDE3ODcxMTA2Mjd8MA&ixlib=rb-4.1.0&q=85)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/55" />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-2">
            <CarProfile size={28} weight="bold" />
            <div className="font-display text-2xl font-bold tracking-tight">SHOWROOM FINANCE</div>
          </div>
          <div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-white/60 mb-4">
              Pantau. Tagih. Bertumbuh.
            </div>
            <div className="font-display text-4xl font-bold leading-tight max-w-md">
              Kelola penjualan cash & kredit mobil, deteksi keterlambatan cicilan sebelum jadi masalah.
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-16 bg-white">
        <form onSubmit={onSubmit} className="w-full max-w-sm">
          <div className="mb-10">
            <div className="text-[11px] tracking-[0.3em] uppercase text-gray-500 mb-3">Masuk</div>
            <h1 className="font-display text-4xl font-bold tracking-tight">
              Selamat Datang
            </h1>
            <p className="mt-3 text-sm text-gray-600">
              Masuk untuk mengelola penjualan dan cicilan.
            </p>
          </div>
          <div className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-xs uppercase tracking-wider font-semibold">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="login-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-2 h-11"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs uppercase tracking-wider font-semibold">Password</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2 h-11"
              />
            </div>
            <Button
              type="submit"
              data-testid="login-submit"
              disabled={loading}
              className="w-full h-11 rounded-none bg-[#0A0A0A] hover:bg-gray-800 text-white uppercase tracking-wider text-xs font-semibold"
            >
              {loading ? "Memproses..." : "Masuk"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
